import { margin } from "polished";
import React from "react";
import Gallery from "react-image-gallery";

// import data from "./data"
import "react-image-gallery/styles/scss/image-gallery.scss";
import "./style.scss";

const ImageGallery = ({ data }) => {
  const { images = [] } = data;

  return (
    <div
      className="accounts-row__wrap"
      style={{ marginTop: "10px", marginBottom: "10px" }}
    >
      <Gallery
        items={images.map(({ url }) => ({
          original: url,
          thumbnail: url,
        }))}
      />
    </div>
  );
};

export default ImageGallery;
